export class DashboardDto {
    couponRedeemed: Number = 0;
    totalB2bOrderPlaced: Number = 0;
    totalFeedbackUnResolved: Number = 0;
    totalWebCustomers: Number = 0;
    webOrders: Number = 0;
    digiboardStatus: DigibardStatus;
}

export class DigibardStatus {
    deviceId: String;
    isActive: String;
    screenName?: String;
}
